export { default as callbackHandler } from './callback'
export { default as loginHandler } from './login'
export { default as logoutHandler } from './logout'
export { default as profileHandler } from './profile'
export { default as signupHandler } from './signup'

export { handlerFactory } from './handlerFactory'
export type { HandleAuth } from './handlerFactory'
